import { render, staticRenderFns } from "./PaginaAdminActividades.vue?vue&type=template&id=0b05d78e"
import script from "./PaginaAdminActividades.vue?vue&type=script&lang=js"
export * from "./PaginaAdminActividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports